module.exports = "<div *ngIf=\"spinnerIsVisible\">\r\n  <mat-spinner class=\"spinner\"></mat-spinner>\r\n</div>\r\n"